import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WindowState {
    isMobile: boolean;
}

const initialState: WindowState = {
    isMobile: typeof window !== 'undefined' ? window.innerWidth < 1024 : false,
};

const WindowSlice = createSlice({
    name: 'window',
    initialState,
    reducers: {
        setIsMobile(state, action: PayloadAction<boolean>) {
            state.isMobile = action.payload;
        },
    },
});

export const { setIsMobile } = WindowSlice.actions;
export default WindowSlice.reducer;
